import { allowedHandoffCountries, type ReturnPortal } from '~/model'
import { getCountryFromBrowserLanguage } from './get-country-from-browser-language'

/**
 * Algorithm:
 * 1. If the user has a preferred browser language, use that
 * 2. Use the country set as receiver in the `returnPortal` object
 * 3. Use `defaultCountry` as a fallback
 */
export const defaultUserCountryCode = (returnPortal: ReturnPortal) => {
  const allowedCountries = allowedHandoffCountries(returnPortal) as string[]
  const userCountry = getCountryFromBrowserLanguage()
  const receiverCountry = returnPortal.address?.address?.countryCode
  const firstAllowedCountry = allowedCountries[0]

  if (userCountry && allowedCountries.includes(userCountry)) {
    return userCountry
  }
  if (receiverCountry && allowedCountries.includes(receiverCountry)) {
    return receiverCountry
  }
  return firstAllowedCountry
}
